import { render } from "./NDateTimeLabel.vue?vue&type=template&id=5255b338&ts=true"
import script from "./NDateTimeLabel.vue?vue&type=script&lang=ts"
export * from "./NDateTimeLabel.vue?vue&type=script&lang=ts"

import "./NDateTimeLabel.vue?vue&type=style&index=0&id=5255b338&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__